class ScrollShadow extends HTMLElement {
  connectedCallback() {
    this.parent = this.querySelector("*")

    this.observer = new IntersectionObserver(this.updateActive.bind(this), {
      root: this.parent,
      rootMargin: '0px',
      threshold: 0.9
    })

    this.parent.querySelectorAll(":scope > :first-child, :scope > :last-child").forEach((element) => {
      this.observer.observe(element)
    })
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    this.parent = null
  }

  updateActive(entries) {
    entries.forEach((entry) => {
      if (entry.target.matches(":first-child")) {
        this.classList.toggle("has-inline-start-shadow", !entry.isIntersecting)
      } else if (entry.target.matches(":last-child")) {
        this.classList.toggle("has-inline-end-shadow", !entry.isIntersecting)
      }
    })
  }
}

// only register on desktop
if (window.matchMedia("(min-width: 1024px)").matches) {
  customElements.define("scroll-shadow", ScrollShadow);
}
